// SPDX-License-Identifier: AGPL-3.0-or-later

export const PRIVACY_SETUP_VERSION = 1;
